import { createStyles } from '@mantine/core';
import { match } from 'ts-pattern';
import Image from 'next/image';

import { getCdnUrl } from '~/domains/assets/utils/getCdnUrl';

const useStyles = createStyles(() => ({
  logo: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface WhalersClubPromoLogoProps {
  tierIndex: number;
  hasProgress?: boolean;
}

function WhalersClubPromoLogo({ tierIndex, hasProgress }: WhalersClubPromoLogoProps) {
  const { classes } = useStyles();

  const { imgSrc, imgSize } = match(tierIndex)
    .with(0, () => ({ imgSrc: getCdnUrl('/images/loyalty/WhalersLogoBronze.png'), imgSize: { width: 57, height: 25 }}))
    .with(1, () => ({ imgSrc: getCdnUrl('/images/loyalty/WhalersLogoSilver.png'), imgSize: { width: 47.5, height: 25 }}))
    .with(2, () => ({ imgSrc: getCdnUrl('/images/loyalty/WhalersLogoGold.png'), imgSize: { width: 38, height: 25 }}))
    .with(3, () => ({ imgSrc: getCdnUrl('/images/loyalty/WhalersLogoDiamond.png'), imgSize: { width: 53.7, height: 25 }}))
    .otherwise(() => hasProgress
      ? ({ imgSrc: getCdnUrl('/images/loyalty/WhalersLogoStarted.png'), imgSize: { width: 49, height: 32 }})
      : ({ imgSrc: getCdnUrl('/images/loyalty/WhalersLogoBase.png'), imgSize: { width: 49, height: 32 } })
);

  return (
    <div className={classes.logo}>
      <Image src={imgSrc} alt="Whaler's club logo" {...imgSize} />
    </div>
  );
}

export default WhalersClubPromoLogo;
